import defineProperty from './_define_property';
const map = {};

function fetchN(dotNumber) {
  const number = map[dotNumber];

  if (number) {
    return number;
  }

  const pow = Math.pow(10, dotNumber);
  const kLetter = pow * 1000;
  const MLetter = kLetter * 1000;
  return map[dotNumber] = {
    pow,
    kLetter,
    MLetter
  };
}

defineProperty(Number, 'toHumanString', function () {
  let beforeDot = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;
  let afterDot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
  let sign;
  let numberAbs;

  if (this < 0) {
    sign = '-';
    numberAbs = -this;
  } else {
    sign = '';
    numberAbs = this;
  }

  const n = fetchN(beforeDot);

  if (numberAbs < n.pow) {
    return sign + numberAbs;
  }

  let letter;
  let rounding;

  if (numberAbs < n.kLetter) {
    letter = 'k';
    rounding = 1000;
  } else if (numberAbs < n.MLetter) {
    letter = 'M';
    rounding = 1000000;
  } else {
    letter = 'G';
    rounding = 1000000000;
  }

  if (afterDot == 0) {
    return sign + Math.floor(numberAbs / rounding) + letter;
  }

  const afterN = fetchN(afterDot).pow;
  return sign + Math.floor(afterN * numberAbs / rounding) / afterN + letter;
});